import { FormErrors } from "redux-form";
import {
    required,
    equal,
    validEmail,
    isNumeric,
    validPhoneNumber
} from "../../../util/validators";
import { EditProfileData, EditProfileFormProps } from "./EditProfileForm";

const validateEditProfileForm = (
    values: EditProfileData,
    props: EditProfileFormProps
) => {
    const errors: FormErrors<EditProfileData> = {};
    errors.email = validEmail(values.email as string);
    errors.phoneNumber = validPhoneNumber(values.phoneNumber);
    errors.streetAddress = required(values.streetAddress);

    errors.postalCode = required(values.postalCode);
    if (!errors.postalCode) {
        const realPostalCode = props.postalCodes.find(
            (item) => item.postalCode === values.postalCode
        );
        errors.postalCode =
            realPostalCode === undefined
                ? "Virheellinen postinumero"
                : undefined;
    }

    return errors;
};

export default validateEditProfileForm;



// WEBPACK FOOTER //
// ./src/views/profile/components/ProfileFormValidator.ts